module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-dialog', {
    attrs: {
      "title": "配置区域",
      "size": "small",
      "visible": _vm.AddDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.AddDialogVisible = $event
      }
    }
  }, [_c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.lists,
      "element-loading-text": "拼命加载中",
      "border": "",
      "router": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "员工",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "电话",
      "prop": "tel"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "数据类型"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": this.form2.Id !== ''
    },
    model: {
      value: (_vm.form.DataType),
      callback: function($$v) {
        _vm.$set(_vm.form, "DataType", $$v)
      },
      expression: "form.DataType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("测试")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("正式")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属部门"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.form.BuessionPartId),
      callback: function($$v) {
        _vm.$set(_vm.form, "BuessionPartId", $$v)
      },
      expression: "form.BuessionPartId"
    }
  }, _vm._l((_vm.departmentList), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    }, [_c('span', {
      staticClass: "optionsp"
    }, [_vm._v(_vm._s(item.Name))])])
  })), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.addDepartment
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _vm._l((_vm.ProvList), function(item, index) {
    return _c('el-form-item', {
      attrs: {
        "label": '所属区域' + (index + 1)
      }
    }, [_c('el-select', {
      staticClass: "selLength",
      attrs: {
        "placeholder": "选择省",
        "filterable": ""
      },
      on: {
        "change": function($event) {
          _vm.changeProv(index)
        }
      },
      model: {
        value: (item.ProvId),
        callback: function($$v) {
          _vm.$set(item, "ProvId", $$v)
        },
        expression: "item.ProvId"
      }
    }, _vm._l((_vm.provinceList), function(item) {
      return _c('el-option', {
        key: item.Id,
        attrs: {
          "label": item.Name,
          "value": item.Id
        }
      }, [_c('span', {
        staticClass: "optionsp"
      }, [_vm._v(_vm._s(item.Name))])])
    })), _vm._v(" "), _c('el-select', {
      staticClass: "selLength",
      attrs: {
        "placeholder": "选择市",
        "filterable": ""
      },
      model: {
        value: (item.CityId),
        callback: function($$v) {
          _vm.$set(item, "CityId", $$v)
        },
        expression: "item.CityId"
      }
    }, _vm._l((_vm.CityList), function(item) {
      return _c('el-option', {
        key: item.Id,
        attrs: {
          "label": item.Name,
          "value": item.Id
        }
      }, [_c('span', {
        staticClass: "optionsp"
      }, [_vm._v(_vm._s(item.Name))])])
    })), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isAddBtnShow[index]),
        expression: "isAddBtnShow[index]"
      }],
      staticClass: "fa fa-plus-circle",
      on: {
        "click": _vm.addList
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isDelBtnShow[index]),
        expression: "isDelBtnShow[index]"
      }],
      staticClass: "fa fa-minus-circle",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeList(index)
        }
      }
    })], 1)
  })], 2), _vm._v(" "), _c('el-row', {
    staticClass: "footer"
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 1)], 1), _vm._v(" "), _c('addDepartment', {
    ref: "refDepartment",
    on: {
      "updata": _vm.addDialogUpdata
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b62503e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Agent/AddEmployee/components/setEmployeeArea/index.vue
// module id = 1403
// module chunks = 1